

export const PROPERTY_TYPE = Object.freeze({
    b: {name: 'b', description: 'boolean' },
    v: {name: 'v', description: 'string' },
    n: {name: 'n', description: 'number'}
  });